"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _uuid = _interopRequireDefault(require("uuid"));
var _ui = require("../actions/ui");
var _UIState = _interopRequireDefault(require("../store/UIState"));
/**
 * Hook for notification
 *
 * @returns {{ toasts: { id: string, timeout: number }, onCloseToast: (id: string) => undefined }}
 */
var useNotification = function useNotification() {
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    toasts = _useState2[0],
    setToasts = _useState2[1];
  var _useContext = (0, _react.useContext)(_UIState["default"]),
    _useContext$state = _useContext.state,
    isSuccessNotificationShown = _useContext$state.isSuccessNotificationShown,
    isFailureNotificationShown = _useContext$state.isFailureNotificationShown,
    isGetQuestionsInProgress = _useContext$state.isGetQuestionsInProgress,
    isSubmitInProgress = _useContext$state.isSubmitInProgress,
    isSurveyEnabled = _useContext$state.isSurveyEnabled,
    isSurveySubmitted = _useContext$state.isSurveySubmitted,
    dispatch = _useContext.dispatch;

  // Action Handlers
  var hideNotification = (0, _react.useCallback)(function () {
    var action = (0, _ui.hideSuccessNotification)();
    dispatch(action);
  }, []);

  // Open and Close toasts
  var onOpenToast = (0, _react.useCallback)(function (config) {
    var type = config.type,
      message = config.message;
    var uid = _uuid["default"].v4();
    setToasts(toasts.concat({
      id: "".concat(uid),
      timeout: 3000,
      type: type,
      message: message
    }));
  }, [toasts, setToasts]);
  var onCloseToast = (0, _react.useCallback)(function (id) {
    setToasts(toasts.filter(function (t) {
      return t.id !== id;
    }));
    hideNotification();
  }, [toasts]);

  // Effects
  (0, _react.useEffect)(function () {
    if (isSuccessNotificationShown) {
      onOpenToast({
        type: 'success',
        message: 'feedback.notifications.submit_success'
      });
    }
    if (isFailureNotificationShown) {
      onOpenToast({
        type: 'error',
        message: 'dev_app.error'
      });
    }
  }, [isSuccessNotificationShown, isFailureNotificationShown]);
  return {
    toasts: toasts,
    onCloseToast: onCloseToast,
    isGetQuestionsInProgress: isGetQuestionsInProgress,
    isSubmitInProgress: isSubmitInProgress,
    isSurveyEnabled: isSurveyEnabled,
    isSurveySubmitted: isSurveySubmitted
  };
};
var _default = exports["default"] = useNotification;
//# sourceMappingURL=useNotification.js.map